import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Akcja pod opisem (np. przycisk „Dodaj zawodnika”). */
  action?: ReactNode;
  /** Obramowanie przerywana linia — dla obszarow, w ktore mozna cos upuscic. */
  dashed?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Stan pusty — „Kort wolny / Przeciągnij mecz tutaj”, „Brak zaplanowanego meczu”.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  dashed = false,
  size = 'md',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-xl text-center',
        dashed ? 'border-border-strong border border-dashed' : 'border-border border',
        size === 'sm' ? 'px-4 py-5' : 'px-6 py-10',
        className,
      )}
    >
      {icon && (
        <span className="text-fg-subtle [&_svg]:size-7">{icon}</span>
      )}
      <p className={cn('text-fg font-semibold', size === 'sm' ? 'text-sm' : 'text-base')}>{title}</p>
      {description && <p className="text-fg-subtle max-w-sm text-xs">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
